<template>
  <div class="app-wrapper">
    <div class="main-container">
      <div>
        <navbar />
      </div>
      <app-main />
      <div class="footer pt-5 pb-5">
        <div>
          <span class="mr-20"> Powererd By <img style="cursor: pointer;" class="h-14 mr-20" src="@/assets/home/qyjjlogo@2x.png" alt="" @click="showT = true"></span>
        </div>
        <div class="fs-b mt-5">
          由深圳市快金数据技术服务有限公司 提供技术支持 © 2015-2020
        </div>
      </div>
      <div class="contact-us">
        <a-popover placement="left">
          <template slot="content">
            <div class="flex a-center "><img class="w-32 mr-6" src="@/assets/home/c-u-p@2x.png" alt=""><div><div class="fs-16 f-c-b1">客服电话</div><div class="f-c-b3">0755-83537936</div><div class="f-c-b3">13510023280</div></div></div>
            <div class="flex a-center mt-20"><img class="w-32 mr-6" src="@/assets/home/QQ@2x.png" alt=""><div><div class="fs-16 f-c-b1">QQ群</div><div class="f-c-b3">1104611646</div></div></div>
          </template>
          <div class="bg-blue pd-10"><img class="w-20" src="@/assets/home/msg@2x.png" alt=""></div>
          <div class="f-c-blue bg-w pt-13 pb-13 pl-13 pr-13 fslh-16">联系我们</div>
        </a-popover>

      </div>
    </div>
    <Tips2 :viz.sync="showT" />
    <bot-banner :show="showBanner" />
  </div>
</template>

<script>
import { AppMain, Navbar } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { mapState } from 'vuex'
import Tips2 from '@/components/tips2'
import botBanner from '@/components/botBanner.vue'
export default {
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    Tips2,
    botBanner
  },
  mixins: [ResizeMixin],
  data() {
    return {
      showT: false,
      showBanner: false
    }
  },
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader
    })
  }
}
</script>

<style lang="scss" scoped>
  @import "@framework/styles/mixin.scss";
  // @import "@framework/styles/variables.scss";

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;

    &.mobile.openSidebar {
      position: fixed;
      top: 0;
    }
  }
  .footer{
    height: 44px;
    color: #000;
    font-size: 12px;
    background: rgba(0, 0, 0, 0.04);
    text-align: center;
  }
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .main-container{
    position: relative;
  }
  .contact-us{
    position: fixed;
    top: 50%;
    right: 0;
    width: 40px;
    z-index: 1;

  }

</style>
